<template>
  <v-card>
    <v-card-title class="dialog-header"
      ><span>User Settings</span>
      <v-icon color="#0068B5" size="25" @click="close">mdi-close</v-icon>
    </v-card-title>

    <div class="user-settings-wrap">
      <v-btn class="custom-btn" width="240px" @click="handlerClickChangePassword"
        >Change password</v-btn
      >
      <v-btn
        v-if="me.isWhitelistAdmin"
        class="custom-btn"
        width="240px"
        @click="handlerClickAdminSettings"
        >Admin settings</v-btn
      >
      <v-btn class="custom-btn" width="240px" @click="handlerClickSignOut">Sign out</v-btn>
    </div>
  </v-card>
</template>

<script lang="ts" src="./index.ts"></script>

<style scoped lang="scss" src="./index.scss"></style>
